import { useRangePresets } from '@crm/hooks/useRangePicker'
import { useQueryUpdate } from '@shared/hooks'
import { DEFAULT_ISO_DATE_FORMAT, defaultFilters } from '@shared/utils'
import { DatePicker } from 'antd/lib'
import dayjs, { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

import type { RangePickerProps } from 'antd/lib/date-picker'

const { RangePicker } = DatePicker

type Props = {
  fromParam?: string
  toParam?: string
} & RangePickerProps

export const RangePickerFilter = ({
  fromParam = 'date_from',
  toParam = 'date_to',
  ...props
}: Props) => {
  const { params, updateQuery } = useQueryUpdate()
  const { t } = useTranslation()
  const { styles } = useStyles()
  const { rangePresets } = useRangePresets()

  const queryFromParam = params?.[fromParam]
  const queryToParam = params?.[toParam]

  const pickerValue =
    queryFromParam || queryToParam
      ? ([
          queryFromParam ? dayjs(queryFromParam) : null,
          queryToParam ? dayjs(queryToParam) : null
        ] as [Dayjs | null, Dayjs | null])
      : undefined

  return (
    <RangePicker
      value={pickerValue}
      format={DEFAULT_ISO_DATE_FORMAT}
      className={styles.rangePicker}
      placeholder={[t('created_at_date_start'), t('created_at_date_end')]}
      onChange={(_, [fromPickerValue, toPickerValue]) =>
        updateQuery({
          [fromParam]: fromPickerValue,
          [toParam]: toPickerValue,
          page: defaultFilters.page
        })
      }
      presets={rangePresets}
      {...props}
    />
  )
}
